import {
  ChangeDetectionStrategy,
  Component,
  OnChanges,
  SimpleChanges,
  input,
  output,
  viewChild
} from '@angular/core';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { ViewTab } from '../../../../models/view.model';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-view-selector',
    templateUrl: './view-selector.component.html',
    styleUrls: ['./view-selector.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatButton,
        MatMenuTrigger,
        MatIcon,
        MatMenu,
        MatMenuItem,
    ]
})
export class ViewSelectorComponent implements OnChanges {
  private _isChanged = false;

  readonly viewTabs = input<ViewTab[]>(undefined);
  readonly disabled = input(false);
  readonly selectionMode = input<'single' | 'multi'>(undefined);
  readonly viewTabsVisibilityChange = output<ViewTab[]>();
  readonly trigger = viewChild(MatMenuTrigger);

  visibleViewTabsCount = 0;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['viewTabs']) {
      this.visibleViewTabsCount = this.viewTabs()?.length > 0 ? this.viewTabs().filter((x) => x.isVisible).length : 0;
    }
  }

  onViewTabClick(event: Event, viewTab: ViewTab) {
    const selectionMode = this.selectionMode();
    if (selectionMode === 'multi') {
      viewTab.isVisible = !viewTab.isVisible;
      this.visibleViewTabsCount += viewTab.isVisible ? 1 : -1;
      this._isChanged = true;

      event.stopPropagation();
    } else if (selectionMode === 'single') {
      this.viewTabs().forEach((x) => {
        x.isVisible = x.viewId == viewTab.viewId;
      });

      this.visibleViewTabsCount = 1;
      this._isChanged = true;

      this.trigger().closeMenu();
    }
  }

  onClose() {
    if (this._isChanged) {
      this._isChanged = false;
      this.viewTabsVisibilityChange.emit(this.viewTabs());
    }
  }
}
